<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router/composables'
import { ERROR_PAGE_LEVEL } from '@/constants'

withDefaults(
  defineProps<{
    level: ERROR_PAGE_LEVEL
  }>()
  , {
    level: ERROR_PAGE_LEVEL.DEFAULT,
  },
)

const route = useRoute()
const message = ref('')
onMounted(() => {
  try {
    message.value = window.decodeURIComponent(route.query.message as string) || '服务器错误'
  }
  catch {}
})

function onRetry() {
  window.location.href = window.decodeURIComponent(route.query.redirect as string ?? '/')
}
</script>

<template>
  <div>
    <BasicNavbar v-if="level === ERROR_PAGE_LEVEL.DEFAULT" />
    <div class="py-4 px-8 flex flex-col items-center justify-center h-screen bg-white">
      <img class="w-100" src="@/assets/cover-error.png">

      <p class="mt-8 w-full text-#666 text-center">
        {{ message }}
      </p>

      <button
        class="mt-15 px-4 py-2 text-primary border-primary border-1 border-solid rounded-full"
        @click="onRetry"
      >
        重试
      </button>
    </div>
  </div>
</template>
